import { EXPLORE_FUNDS, EXPLORE_FUNDS_ERROR, EXPLORE_FUNDS_HIDE_ERROR, EXPLORE_FUNDS_START_LOADER, EXPLORE_FUNDS_STOP_LOADER, } from "../interface/IExploreFunds";
const initState = {
    data: { MFCollection: [], exploreContent: {} },
    loader: false,
    errorData: {
        error: null,
        isOpen: false,
    },
};
const exploreFundsReducer = (state = initState, action) => {
    switch (action.type) {
        case EXPLORE_FUNDS:
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        case EXPLORE_FUNDS_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case EXPLORE_FUNDS_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: initState.errorData });
        case EXPLORE_FUNDS_START_LOADER:
            return Object.assign(Object.assign({}, state), { loader: true });
        case EXPLORE_FUNDS_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { loader: false });
        default:
            return Object.assign({}, state);
    }
};
export default exploreFundsReducer;
